<h1>Protect them in just a few clicks</h1>
<div class="subtitle">
  Bigyan ng protection sa aksidente at sakit ang pamilyang naiwan sa Pinas para panatag habang nasa abroad.
</div>

<!-- STEP 1 -->
<div class="step">
  <div class="step-header">
    <div class="step-number">1</div>
    <div>
      <div class="step-title">Piliin ang civil status ng Overseas Filipino</div>
      <div class="step-desc">
        This helps us know who can be included in your coverage.
      </div>
    </div>
  </div>

  <select
    [value]="request().policyHolderCivilStatus ?? ''"
    (change)="onCivilStatusChange($event)"
  >
    <option value="" disabled>Select civil status *</option>
    <option value="MARRIED">Married</option>
    <option value="SINGLE">Single</option>
    <option value="WIDOWED">Widowed</option>
    <option value="SEPARATED">Legally Separated</option>
  </select>

  @if (state.needsWithChildren()) {
    <div class="with-children-field">
      <div class="with-children-copy">
        <div class="with-children-title">With children?</div>
        <div class="with-children-desc">This determines who can be included as dependents.</div>
      </div>

      <div class="with-children-options" role="radiogroup" aria-label="With children">
        <label class="binary-option" [class.active]="request().withChildren === true">
          <input
            type="radio"
            name="withChildren"
            [checked]="request().withChildren === true"
            (change)="onWithChildrenChange(true)"
          />
          Yes
        </label>

        <label class="binary-option" [class.active]="request().withChildren === false">
          <input
            type="radio"
            name="withChildren"
            [checked]="request().withChildren === false"
            (change)="onWithChildrenChange(false)"
          />
          No
        </label>
      </div>
    </div>
  }

  <!-- BREAKDOWN -->
  <div class="breakdown-box">

    <!-- ERROR -->
    @if (state.error()) {
      <div class="state-message error">
        ⚠️ {{ state.error() }}
      </div>
    }

    @if (state.retrievingFromApi()) {
      <div class="loading">
        Calculating coverage...
      </div>
    }

    @if (!request().policyHolderCivilStatus) {
      Select civil status to see coverage summary.
    }

    @if (request().policyHolderCivilStatus && state.needsWithChildren() && request().withChildren === null) {
      Select if the Overseas Filipino has children to see coverage summary.
    }

    @if (!state.retrievingFromApi() && breakdown()) {
      @for (section of breakdown(); track section.title; let last = $last) {

        <div class="section-title">
          {{ section.title }}
        </div>

        @for (row of section.rows; track row.label) {
          <div class="breakdown-row">
            <span>{{ row.label }}</span>
            <span><span class="currency">₱</span> {{ row.amount | number }}</span>
          </div>
        }

        @if (!last) {
          <div class="breakdown-divider"></div>
        }
      }
    }

  </div>
</div>

<!-- TOTAL -->
<div class="total">
  @if (state.retrievingFromApi()) {
    Calculating...
  } @else if (totalPremium() !== null) {
    Total: <span class="currency">₱</span> {{ totalPremium() | number }}
  } @else {
    Total: --
  }
</div>

<button
  class="primary"
  (click)="validate()"
  [disabled]="state.loading() || !state.isValid() || state.error()"
>
  @if (state.loading()) {
    <span class="spinner"></span>
  } @else {
    Buy Now
  }
</button>
